/** @format */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next/hooks';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEn from './assets/locales/en/translation.json';
import translationNo from './assets/locales/nb/translation.json';

i18n
	.use(Backend)
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources: {
			en: { translation: translationEn },
			nb: { translation: translationNo },
		},

		lng: 'nb',
		fallbackLng: 'en',
		// debug only when not in production
		debug: process.env.NODE_ENV !== 'production',
		ns: ['translations'],
		defaultNS: 'translations',
		keySeparator: false,
		interpolation: {
			escapeValue: false,
			formatSeparator: ',',
		},
		react: {
			wait: true,
		},
	});

export default i18n;
